import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import ResetPassword from "../pages/auth/reset-password";
import Layout from "../components/feature/Layout";
import { ProtectedRoute, GuestRoute } from "../components/feature/RouteGuards";

const Dashboard = lazy(() => import("../pages/dashboard/page"));
const Kitchen = lazy(() => import("../pages/kitchen/page"));
const OrderCapture = lazy(() => import("../pages/order-capture/page"));
const History = lazy(() => import("../pages/history/page"));
const Customers = lazy(() => import("../pages/customers/page"));
const Products = lazy(() => import("../pages/products/page"));
const Settings = lazy(() => import("../pages/settings/page"));
const Inventory = lazy(() => import("../pages/inventory/page"));
const BusinessSales = lazy(() => import("../pages/business-sales/page"));
const Billing = lazy(() => import("../pages/billing/page"));
const Reports = lazy(() => import("../pages/reports/page"));
const RouteCustomers = lazy(() => import("../pages/route-customers/page"));
const Admin = lazy(() => import("../pages/admin/page"));
const BusinessDetail = lazy(() => import("../pages/admin/business-detail/page"));
const PublicOrder = lazy(() => import("../pages/public-order/page"));
const Demo = lazy(() => import("../pages/demo/page"));

const routes: RouteObject[] = [
  { path: "/demo", element: <Demo /> },
  {
    path: "/pedir/:businessSlug",
    element: <PublicOrder />,
  },
  {
    path: "/pedir-b2b/:businessSlug",
    element: <PublicOrder />,
  },
  {
    path: "/order/:businessSlug",
    element: <PublicOrder />,
  },
  {
    path: "/",
    element: (
      <GuestRoute>
        <Login />
      </GuestRoute>
    ),
  },
  {
    path: "/login",
    element: (
      <GuestRoute>
        <Login />
      </GuestRoute>
    ),
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin']}>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/kitchen",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin', 'supervisor']}>
            <Kitchen />
          </ProtectedRoute>
        ),
      },
      {
        path: "/orders/capture",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin', 'supervisor', 'employee']}>
            <OrderCapture />
          </ProtectedRoute>
        ),
      },
      {
        path: "/orders/history",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin', 'supervisor', 'employee']}>
            <History />
          </ProtectedRoute>
        ),
      },
      {
        path: "/route-customers",
        element: (
          <ProtectedRoute allowedRoles={['employee']}>
            <RouteCustomers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/customers",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin']}>
            <Customers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/products",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin', 'employee']}>
            <Products />
          </ProtectedRoute>
        ),
      },
      {
        path: "/inventory",
        element: (
          <ProtectedRoute allowedRoles={['business_admin', 'employee']}>
            <Inventory />
          </ProtectedRoute>
        ),
      },
      {
        path: "/settings",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin', 'employee']}>
            <Settings />
          </ProtectedRoute>
        ),
      },
      {
        path: "/business-sales",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin', 'employee']}>
            <BusinessSales />
          </ProtectedRoute>
        ),
      },
      {
        path: "/billing",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin']}>
            <Billing />
          </ProtectedRoute>
        ),
      },
      {
        path: "/reports",
        element: (
          <ProtectedRoute allowedRoles={['super_admin', 'business_admin']}>
            <Reports />
          </ProtectedRoute>
        ),
      },
      {
        path: "/admin",
        element: (
          <ProtectedRoute allowedRoles={['super_admin']}>
            <Admin />
          </ProtectedRoute>
        ),
      },
      {
        path: "/admin/business/:id",
        element: (
          <ProtectedRoute allowedRoles={['super_admin']}>
            <BusinessDetail />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
